module.exports = __webpack_public_path__ + "img/google-play.3a28b72.svg";